module.exports = __webpack_public_path__ + "assets/a086b28b9a9f1916653d42e67bec7acf.json";